<div class="category-header hmf-mt-l hmf-pt-l">
	<p class="hmf-subheader-bold-l hmf-mb-0">Shop by Category</p>
</div>
<div class="category-section">
	<div class="category-row hmf-mt-s hmf-mb-s">
		<div *ngFor="let category of categories; let i= index;">
			<div>
				<a [href]="category.link"><img [src]="category.imgUrl" [alt]="category.title"></a>
			</div>
			<a class="category-label hmf-label-xs" [href]="category.link">{{category.title}}</a>
		</div>
	</div>
  </div>
